import { render, staticRenderFns } from "./blog_single.vue?vue&type=template&id=8ef28846&"
import script from "./blog_single.vue?vue&type=script&lang=js&"
export * from "./blog_single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports